<template>
  <div style="margin: 25px">
    <vue-good-table
      :columns="ekstreGenelcolumns"
      :rows="ekstreGenelList"
      :rtl="dir"
      max-height="350px"
      :fixed-header="true"
      :row-style-class="rowStyleClassFn"
    >
      <template slot="table-row" slot-scope="props">
        <!-- Column: Name -->
        <div v-if="props.column.field === 'TRANSDATE'" class="text-nowrap">
          <span class="text-nowrap">{{ props.row.TRANSDATE }}</span>
        </div>
      </template>

      <!-- pagination -->
    </vue-good-table>
  </div>
</template>
<script>
import Store from "../../../../store/store";
import state from "../../../../store/state";
export default {
  data() {
    return {
      dir: false,

      ekstreGenelcolumns: [
        {
          label: "Lot No",
          field: "LOTNO"
        },
        {
          label: "Depo",
          field: "DEPOTID"
        },
        {
          label: "Karşı Lot No",
          field: "OPPLOTNO"
        },
        {
          label: "Miktar",
          field: "QREM"
        }
      ],
      ekstreGenelList: []
    };
  },
  methods: {
    rowStyleClassFn(row) {
      return "VGT-row";
    },
    ekstreGenel() {
      var vm = this;
      var vs = this.$vs;

      vm.veriler = [];

      const soap = require("soap");
      let url = state.sistemAddress;
      url = url.replace("sistem", "uzumMrp");
      const args = {
        token: Store.state.tokenId,
        STOCKID: Store.state.account.stokId
      };

      soap.createClient(url, function(err, client) {
        client.STOCKLOTSLIST(args, function(err, result) {
          if (result.STOCKLOTSLISTResult == "-1") {
            Store.dispatch("logout");
            //this.$store.dispatch('login', payload)
          }
          vm.veriler = JSON.parse(result.STOCKLOTSLISTResult);
          try {
            if (vm.veriler.response == "Ok") {
              let lotsList = JSON.parse(vm.veriler.jsonData);

              vm.ekstreGenelList = lotsList;
              console.log(vm.ekstreGenelList);
              vm.$store.commit(
                "account/EXCEL_YADIRILACAK_DATA",
                vm.ekstreGenelList
              );
            } else {
              vs.notify({
                title: "Reçete Listesi",
                text: vm.veriler.message,
                iconPack: "feather",
                icon: "icon-alert-circle",
                color: "warning",
                position: "top-center"
              });
            }
          } catch (error) {
            vs.notify({
              title: "Reçete Listesi",
              text: "Beklenmedik Hata",
              iconPack: "feather",
              icon: "icon-alert-circle",
              color: "danger",
              position: "top-center"
            });
          }
        });
      });
    }
  },
  created() {
    this.ekstreGenel();
  }
};
</script>
<style lang="scss">
.VGT-row:hover {
  background-color: rgb(219, 219, 250);
}
</style>
